import { createApp } from 'vue';
import TeamDropdown from './vue/team-dropdown.vue';
import { context } from './team-dropdown.config.yml';


const app = createApp(TeamDropdown, context);
app.mount('#team-dropdown-root');
